import Svg from 'components/utilities/svg'

const MenuIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Menu Icon</title>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </Svg>
)

MenuIcon.displayName = 'Menu'

export default MenuIcon
